import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '52px',
    height: '28px',
    padding: '0',
    margin: '0'
  },

  switchBase: {
    padding: '2px',

    '&$checked': {
      transform: 'translateX(24px)',
      color: 'white',

      '& + $track': {
        border: '1px solid #B64FCD',
        backgroundColor: '#B64FCD',
        opacity: '1'
      }
    }
  },

  thumb: {
    width: '24px',
    height: '24px'
  },

  track: {
    borderRadius: 100,
    border: '1px solid #E1E1E1',
    boxSizing: 'border-box',
    backgroundColor: '#F8D8FF',
    opacity: '1',
    transition: theme.transitions.create(['background-color', 'border'])
  },

  checked: {},

  labelRoot: {
    margin: '0'
  },

  label: {
    marginLeft: '12px',
    marginRight: '0',
    fontSize: theme.size.base,
    color: '#505050',
    userSelect: 'none'
  }
}))

export default useStyles
